import { useQuery } from '@tanstack/react-query';
import type { PlanningsData, TempDemandData } from './types';

const QUERY_KEYS = {
  plannings: ['new-opti-form-timeless', 'plannings'],
  tempDemand: ['new-opti-form-timeless', 'temp-demand'],
};

export function useTempDemandData() {
  return useQuery<TempDemandData>({
    queryKey: QUERY_KEYS.tempDemand,
    queryFn: async () => {
      const res = await fetch('/api/new-opti-form-timeless/temp-demand');
      if (!res.ok) throw new Error('Failed to fetch temp demand data');
      return res.json() as Promise<TempDemandData>;
    },
  });
}

export function usePlannings() {
  return useQuery<PlanningsData>({
    queryKey: QUERY_KEYS.plannings,
    queryFn: async () => {
      const res = await fetch('/api/new-opti-form-timeless/plannings');
      if (!res.ok) throw new Error('Failed to fetch plannings');
      return res.json() as Promise<PlanningsData>;
    },
  });
}
